import ConsentCheckbox from '@/components/order/order-summary/ConsentCheckbox';
import settings from '@/constants/constants';
import { Link } from '@montugroup/design-system';
import React from 'react';

interface ValidIDCheckboxProps {
  size?: 'small' | 'medium';
  value: boolean;
  onChange: (value: boolean) => void;
  deliveryText?: 'collection' | 'delivery';
}

export default function ValidIDCheckbox({ size, value, onChange, deliveryText = 'delivery' }: ValidIDCheckboxProps) {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.checked);
  };

  return (
    <ConsentCheckbox
      trackingId="validIDCondition"
      testid="validid-checkbox"
      text={
        <>
          By ticking this you agree to be present with{' '}
          <Link
            id="valid_id_checkbox_help_link"
            href={`${settings.support.site.url}/articles/14108814616463-Identification-required-to-receive-your-medication`}
            target="_blank"
            rel="noopener noreferrer"
          >
            valid ID
          </Link>{' '}
          for {deliveryText}.
        </>
      }
      size={size}
      checked={value}
      onChange={handleChange}
    />
  );
}
